

































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import AuthCard from '@/components/layout/auth/AuthCard.vue'
import RouteName from '@/utils/RouteName'
import TranslationModule from '@/utils/TranslationModule'
import { Member } from '@/types/Member.type'
import { UserRole } from '@/types/UserRole.type'

const User = namespace('user')

@Component({
    components: {
        AuthCard,
    },
})
export default class Register extends Vue {
    @User.State me!: Member
    RouteName: typeof RouteName = RouteName
    @User.Getter hasRole!: (role: UserRole) => boolean
    TranslationModule: typeof TranslationModule = TranslationModule

    get isLesTalents() {
        return this.$route.query && this.$route.query.context === 'lestalents'
    }

    get isLeClubPartnerContact(): boolean {
        return this.hasRole('ROLE_BL_LECLUB_PARTNER_CONTACT')
    }

    get tabs() {
        return [
            { name: RouteName.UPDATE_ACCOUNT, label: this.$trans('auth.update.tab.infos', TranslationModule.COMMON) },
            {
                name: RouteName.UPDATE_ACCOUNT_PASSWORD,
                label: this.$trans('auth.update.tab.password', TranslationModule.COMMON),
            },
        ]
    }

    mounted() {
        if (this.$route.query.showWelcomeModal) {
            this.$router.push({ query: {} })
            this.$modal.show('modal-onboarding-contact-partner')
        }

        if (!this.me) {
            this.$router.push({
                name: RouteName.LOGIN,
                query: {
                    redirectUrl: this.$route.fullPath,
                },
            })
        }
    }
}
